/** People Landing — campos del bloque "image". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ImageField } from '../ImageField';
import type { EditorFieldProps } from '../types';

export function ImageFields({ draft, set, imageUrls, pageSlug }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <ImageField
        pageSlug={pageSlug}
        imageKey={draft.imageKey}
        previewUrl={draft.imageKey ? imageUrls[draft.imageKey] : undefined}
        onChange={(k) => set({ imageKey: k })}
      />
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.size', 'Tamaño')}</Label>
        <div className="flex gap-1.5">
          {(['sm', 'md', 'lg', 'full'] as const).map((s) => (
            <Button
              key={s}
              type="button"
              size="sm"
              variant={(draft.size ?? 'md') === s ? 'default' : 'outline'}
              onClick={() => set({ size: s })}
            >
              {
                {
                  sm: t('people_landing.editor.size_sm', 'Chica'),
                  md: t('people_landing.editor.size_md', 'Media'),
                  lg: t('people_landing.editor.size_lg', 'Grande'),
                  full: t('people_landing.editor.size_full', 'Completa'),
                }[s]
              }
            </Button>
          ))}
        </div>
      </div>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.caption', 'Epígrafe (opcional)')}</Label>
        <Input
          value={draft.caption ?? ''}
          onChange={(e) => set({ caption: e.target.value })}
        />
      </div>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.image_link', 'Link al hacer click (opcional)')}</Label>
        <Input
          value={draft.url ?? ''}
          onChange={(e) => set({ url: e.target.value })}
          placeholder="https://…"
        />
      </div>
    </>
  );
}
